import { render } from "./index.vue?vue&type=template&id=bac78cae"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=bac78cae&lang=scss"
script.render = render

export default script